<template>
  <!-- Wrap everything in a flex container that provides vertical spacing -->
  <div v-if="selectedBooking" class="d-flex flex-column gap-4 pb-4">
    <Booking :booking="selectedBooking" :isPanelView="true" />
    <ReservationSummary
      :booking="selectedBooking"
      :hide-action-button="isMobile"
    />

    <!-- For the 2-column layout, use .row + .col-* plus gutter (g-3) -->
    <div class="row g-3 align-items-stretch p-2 p-md-0">
      <div class="col-12 col-md-6">
        <TravellersSection :booking="selectedBooking" />
      </div>
      <div class="col-12 col-md-6">
        <PaymentSection :booking="selectedBooking" />
      </div>
    </div>
    <div class="p-2 p-md-0">
      <DocumentsSection :booking="selectedBooking" />
    </div>
    <div class="p-2 p-md-0">
      <NeedHelpSection />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  // Store
  import { useStore } from '@/store'
  import useScreenSize from '@/composables/useScreenSize'

  // Components
  import Booking from '@/components/common/Booking.vue'
  import ReservationSummary from '@/components/common/ReservationSummary.vue'
  import DocumentsSection from '@/components/ConfirmedReservations/BookingPanel/DocumentsSection/DocumentsSection.vue'
  import PaymentSection from '@/components/ConfirmedReservations/BookingPanel/PaymentSection/PaymentSection.vue'
  import TravellersSection from '@/components/ConfirmedReservations/BookingPanel/TravellersSection/TravellersSection.vue'
  import NeedHelpSection from '@/components/ConfirmedReservations/BookingPanel/NeedHelpSection/NeedHelpSection.vue'
  // import StickyBar from '@/components/ConfirmedReservations/BookingPanel/StickyBar.vue'

  // Get the selected booking from the Vuex store
  const store = useStore()
  const { isMobile } = useScreenSize()
  const selectedBooking = computed(
    () => store.getters['booking/selectedBooking']
  )
</script>
